const InputField = ({
  name,
  title,
  placeholder,
  type = "text",
  options = [],
  value,
  onChange,
}) => {
  const handleKeyDown = (e) => {
    if (type === "number" && !/[0-9]/.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <label className="text-[14px] font-medium text-[#010203] font-montserrat">
        {title}
      </label>

      {type === "select" ? (
        <div className="relative">
          <select
            name={name}
            className="w-full appearance-none border border-gray-300 rounded-lg px-4 py-2 text-gray-700 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-[#E98362] focus:ring-offset-0 transition-all duration-200 ease-in-out hover:border-[#E98362]"
            value={value}
            onChange={onChange}
          >
            <option value="" disabled hidden>
              {placeholder}
            </option>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      ) : (
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            if (type === "number") {
              // Hanya angka yang boleh masuk
              const newValue = e.target.value.replace(/\D/g, "");
              onChange({ target: { name, value: newValue } });
            } else {
              onChange(e);
            }
          }}
          onKeyDown={handleKeyDown}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-700 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-[#E98362] focus:ring-offset-0 transition-all duration-200 ease-in-out hover:border-[#E98362]"
        />
      )}
    </div>
  );
};

export default InputField;
